import { Card, Row, Col } from "react-bootstrap";

import { formatCurrency, formatNumber } from "../../utils/functions";
import EdelmetallBezeichnung from "./EdelmetallBezeichnung";

const DetailEdelmetall = (props) => {
  let { auftrag, ...attribute } = props || {};

  if (!auftrag) return;
  const isVerkauf = !!String(auftrag.geschaeftsart).match(/VK$/);
  const header = isVerkauf ? "Bestellung" : "Ankauf";
  const order = auftrag.order || {};
  const auftragsDetails = auftrag.auftragsDetails || {};

  return <Card className="h-100" {...attribute}>
    <Card.Header>{header}</Card.Header>
    <Card.Body>
      <Row>
        <Col >Edelmetall {auftrag.kennziffer}</Col><Col>
          {auftrag.text
            ? auftrag.text
            : <EdelmetallBezeichnung kennziffer={auftrag.kennziffer} name={order.name} />
          }
        </Col>
      </Row>
      <Row>
        <Col md="8" lg="6">Anzahl:</Col>
        <Col md="4" lg="3" className="text-end nowrap">{formatNumber(order.anzahl, {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        })}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6">Preis:</Col>
        <Col md="4" lg="3" className="text-end nowrap">{formatCurrency(order.preis)}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6">Konditions&shy;änderung/Gebühr:</Col>
        <Col md="4" lg="3" className="text-end nowrap">{formatCurrency(auftragsDetails.konditionsAenderung)}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6">Versand&shy;kosten:</Col>
        <Col md="4" lg="3" className="text-end nowrap">{formatCurrency(order.versandkosten)}</Col>
      </Row>
      <Row>
        <Col md="8" lg="6">Provision:</Col>
        <Col md="4" lg="3" className="text-end nowrap">{formatCurrency(auftragsDetails.provision)}</Col>
        <Col>pro Stück</Col>
      </Row>
      <Row>
        <Col md="8" lg="6">Gesamt&shy;betrag:</Col>
        <Col md="4" lg="3" className="text-end nowrap">{formatCurrency(order.endsumme)}</Col>
      </Row>
    </Card.Body>
  </Card>;
};
export default DetailEdelmetall;
